import Vue from 'vue'
import { getQuery } from '@/functions/app'

const now = new Date().getTime()
let commonLog = {}
const query = location.search
const utmSource = getQuery('utm_source') || ''
const utmMedium = getQuery('utm_medium') || ''
const utmCampaign = getQuery('utm_campaign') || ''

function sendMsg(url) {
  const s = document.createElement('img')
  s.height = 1
  s.width = 1
  s.src = url
}

const initAna = function(appInfo) {
  appInfo = appInfo || {}
  commonLog = {
    al: appInfo.lnCode || 'en', // App语言
    bst: '', // 用户绑卡状态
    car: appInfo.carrier || '',
    curp: document.title, // 当前页面
    cr: appInfo.countryCode || '',
    ct: '',
    dch: '', // 安装渠道标识
    dd: '' + window.devicePixelRatio, // 屏幕密度
    did: appInfo.deviceId || '',
    desp: '', // 跳转页面
    durp: 0,
    di: appInfo.phoneModel || '', // 设备信息
    dr: '', // 屏幕分辨率
    iid: appInfo.cid || '', // 安装唯一标识
    lst: appInfo.loginState || 'a', // 用户登录状态
    lt: 'event', // 报数类型
    lv: '1.0.0',
    nt: appInfo.network || '', // 网络类型
    os: appInfo.client || '',
    osl: navigator.language, // 系统语言
    osv: '', // 系统版本
    pid: '', //	播放ID
    pro: utmSource + '/' + utmMedium + '_' + utmCampaign, // 推广渠道标识
    pst: '', // 用户付费状态
    sid: '', // Session ID
    sim: appInfo.operator || '', // 手机卡运营商
    srcp: document.referrer,
    ver: appInfo.versionName || '',
    tt: now,
    uid: appInfo.uid || 0
  }
}

const serializeMsg = msg => {
  for (const i in msg) {
    const item = ('' + msg[i]).replace(/&/g, '_and_').replace(/\?/g, '_wen_')
    msg[i] = encodeURIComponent('' + item) // 防止入库hive失败
  }
  const param = {
    msg: msg
  }

  for (const i in commonLog) {
    const item = ('' + commonLog[i]).replace(/&/g, '_and_').replace(/\?/g, '_wen_')
    param[i] = encodeURIComponent('' + item)
  }
  param['tt'] = new Date().getTime()
  param['durp'] = new Date().getTime() - now

  return JSON.stringify([param])
}

let _logger = {
  init: initAna,
  event: msg => {
    if (window.getChannelId && window.getChannelId.sendEventLog) {
      const map = {}
      const arr = ['category', 'action', 'label', 'value']
      for (let i in msg) {
        if (!arr.includes(i)) {
          map[i] = msg[i]
        }
      }
      window.getChannelId.sendEventLog(msg.category, msg.action, msg.label, msg.value, JSON.stringify(map))
    } else {
      sendMsg(
        process.env.VUE_APP_LOGGER_SERVER +
          '/i?logtype=event&app_key=' +
          process.env.VUE_APP_LOGGER_APP_KEY +
          '&events=' +
          serializeMsg(msg) +
          '&device_id=' +
          commonLog.did +
          '&timestamp=' +
          now
      )
    }
  }
}

const Logger = {
  install: Vue => {
    // window.logger = _logger
    Vue.logger = _logger
    Vue.prototype.$logger = _logger
  }
}

Vue.use(Logger)

export default Logger
